import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./context/protectedroute";
import Layout from "./components/Layout";
import Jobs from "./pages/Jobs";
import Applications from "./pages/Applications";
import Categories from "./pages/Categories";
import Admins from "./pages/Admins";
import Hrs from "./pages/hr";
import Login from "./pages/Login";
import News from "./pages/News";
import Subscribers from "./pages/Subscribers";
import ContactUs from "./pages/ContactUs";
import BlogTopics from "./pages/blogTopic";
import BlogTemplates from "./pages/templates";
import Authors from "./pages/authors";
import Blogs from "./pages/blogs";
import EmailService from "./pages/email-services";
export default function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
      <Routes>
        {/* login */}
        <Route path="/login" element={<Login />} />

        {/* protected pages */}
        <Route
          path="/jobs"
          element={
            <ProtectedRoute>
              <Layout>
                <Jobs />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <ProtectedRoute>
              <Layout>
                <Applications />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <ProtectedRoute>
              <Layout>
                <Categories />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admins"
          element={
            <ProtectedRoute>
              <Layout>
                <Admins />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/hrs"
          element={
            <ProtectedRoute>
              <Layout>
                <Hrs />
              </Layout>
            </ProtectedRoute>
          }
        />

          <Route
          path="/news"
          element={
            <ProtectedRoute>
              <Layout>
                <News />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/subscribers"
          element={
            <ProtectedRoute>
              <Layout>
                <Subscribers />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/contacts"
          element={
            <ProtectedRoute>
              <Layout>
                <ContactUs />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/email-service"
          element={
            <ProtectedRoute>
              <Layout>
                <EmailService />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/topics"
          element={
            <ProtectedRoute>
              <Layout>
                <BlogTopics />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/blogs"
          element={
            <ProtectedRoute>
              <Layout>
                <Blogs />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/authors"
          element={
            <ProtectedRoute>
              <Layout>
                <Authors />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/templates"
          element={
            <ProtectedRoute>
              <Layout>
                <BlogTemplates />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* default redirect */}
        <Route path="/" element={<Navigate to="/jobs" replace />} />
        <Route path="*" element={<Navigate to="/jobs" replace />} />
      </Routes>
      </HelmetProvider>
    </AuthProvider>
  );
}